import React from "react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const OTHER_AREA = "Other / Not sure";
const REFERRAL_SOURCES = ["Google or web search", "Referred by a friend or family member", "Referred by another attorney", "Existing or past client", "Social media", "Other"];
const inputCls = "rounded-none border-stone-300 focus:border-[#1a2c4e] mt-1";
const selectCls = "rounded-none border-stone-300 focus:ring-0 focus:border-[#1a2c4e] mt-1 h-10";

function Field({ label, required, children }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-widest text-[#4a6d8c]">
        {label}
        {required && " *"}
      </label>
      {children}
    </div>
  );
}

export function ContactIdentityFields({ form, update }) {
  return (
    <>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Name" required>
          <Input data-testid="contact-name-input" value={form.name} onChange={update("name")} className={inputCls} placeholder="Jane Doe" />
        </Field>
        <Field label="Phone">
          <Input data-testid="contact-phone-input" value={form.phone} onChange={update("phone")} className={inputCls} placeholder="(208) 555-0123" />
        </Field>
      </div>
      <Field label="Email" required>
        <Input data-testid="contact-email-input" type="email" value={form.email} onChange={update("email")} className={inputCls} placeholder="jane@example.com" />
      </Field>
    </>
  );
}

export function ContactMatterFields({ form, set, update, practiceAreas }) {
  return (
    <>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="What can we help with?">
          <Select value={form.practice_area} onValueChange={set("practice_area")}>
            <SelectTrigger className={selectCls} data-testid="contact-practice-area-select"><SelectValue placeholder="Select a practice area" /></SelectTrigger>
            <SelectContent className="rounded-none">
              {practiceAreas.map((a) => (
                <SelectItem key={a.id} value={a.title} data-testid={`practice-area-option-${a.id}`}>{a.title}</SelectItem>
              ))}
              <SelectItem value={OTHER_AREA}>{OTHER_AREA}</SelectItem>
            </SelectContent>
          </Select>
        </Field>
        <Field label="How did you hear about us?">
          <Select value={form.referral_source} onValueChange={set("referral_source")}>
            <SelectTrigger className={selectCls} data-testid="contact-referral-select"><SelectValue placeholder="Select an option" /></SelectTrigger>
            <SelectContent className="rounded-none">
              {REFERRAL_SOURCES.map((r) => (
                <SelectItem key={r} value={r}>{r}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      </div>
      <Field label="How can we help?" required>
        <Textarea data-testid="contact-message-input" rows={5} value={form.message} onChange={update("message")} className={inputCls} placeholder="Briefly describe your matter..." />
      </Field>
    </>
  );
}

export function HoneypotField({ value, onChange }) {
  return (
    <div className="absolute -left-[9999px] top-auto h-px w-px overflow-hidden" aria-hidden="true">
      <label htmlFor="contact-website-field">Website</label>
      <input id="contact-website-field" name="website" type="text" tabIndex={-1} autoComplete="off" value={value} onChange={onChange} data-testid="contact-honeypot-input" />
    </div>
  );
}
